module.exports = __webpack_public_path__ + "img/lab.3ae68d94.png";